/*
 * Homepage footnotes: make the superscripts in body copy (¹ ² ³ …) clickable, jumping to the matching entry
 * in sections/soulog-home-footnotes.liquid.
 *
 * Merchants type the superscripts as plain Unicode characters in rich text, so we walk the text nodes and wrap
 * each one in <a href="#shn-note-N">. Skipped: the footnotes section itself, anything already inside a
 * link/button (no nested interactive elements), script/style/form fields, and numbers with no matching entry.
 */
(() => {
	if (window.__soulogFootnoteRefs) return;
	window.__soulogFootnoteRefs = true;

	const SUP = "¹²³⁴⁵⁶⁷⁸⁹";
	const SUP_RE = /[¹²³⁴⁵⁶⁷⁸⁹]/;
	const SKIP = "a, button, script, style, textarea, input, select, template, .shn";

	const link = () => {
		if (!document.querySelector('.shn [id^="shn-note-"]')) return;

		const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
			acceptNode: (node) =>
				SUP_RE.test(node.nodeValue) && !node.parentElement.closest(SKIP)
					? NodeFilter.FILTER_ACCEPT
					: NodeFilter.FILTER_REJECT,
		});
		const nodes = [];
		while (walker.nextNode()) nodes.push(walker.currentNode);

		nodes.forEach((node) => {
			const frag = document.createDocumentFragment();
			let changed = false;
			node.nodeValue.split(/([¹²³⁴⁵⁶⁷⁸⁹])/).forEach((part) => {
				const n = SUP.indexOf(part) + 1;
				const target = part.length === 1 && n > 0 && document.getElementById(`shn-note-${n}`);
				if (target) {
					const a = document.createElement("a");
					a.className = "shn-ref";
					a.href = `#shn-note-${n}`;
					a.textContent = part;
					a.setAttribute("aria-label", `Footnote ${n}`);
					frag.appendChild(a);
					changed = true;
				} else if (part) {
					frag.appendChild(document.createTextNode(part));
				}
			});
			if (changed) node.parentNode.replaceChild(frag, node);
		});

		/* Some sections write the marker as HTML (<sup>1</sup>) instead of a Unicode superscript: link its contents */
		document.querySelectorAll("sup").forEach((sup) => {
			const num = sup.textContent.trim();
			if (!/^\d+$/.test(num) || sup.closest(SKIP) || sup.querySelector("a")) return;
			if (!document.getElementById(`shn-note-${num}`)) return;
			const a = document.createElement("a");
			a.className = "shn-ref";
			a.href = `#shn-note-${num}`;
			a.textContent = num;
			a.setAttribute("aria-label", `Footnote ${num}`);
			sup.replaceChildren(a);
		});
	};

	/* Briefly highlight the entry after jumping, so it stands out in the small print */
	document.addEventListener("click", (e) => {
		const a = e.target.closest("a.shn-ref");
		if (!a) return;
		const target = document.getElementById(a.hash.slice(1));
		if (!target) return;
		e.preventDefault();
		target.scrollIntoView({ behavior: "smooth", block: "center" });
		target.classList.remove("is-flash");
		void target.offsetWidth;
		target.classList.add("is-flash");
		history.replaceState(null, "", a.hash);
	});

	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", link);
	else link();
	document.addEventListener("shopify:section:load", link);
})();
